module.exports = __webpack_public_path__ + "static/media/iso_shirt_blank.5dc8eabc.png";